const UserWeb = () => {
  return <>고객용 웹 관리</>;
};
export default UserWeb;
